import { render, staticRenderFns } from "./CardDates.vue?vue&type=template&id=603f3cdb"
import script from "./CardDates.vue?vue&type=script&lang=js"
export * from "./CardDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports